import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { currentUserSelector } from 'features/auth/login/selectors'
import { useAppSelector } from 'app/hooks'
import { orgAdminsFetchDataSelector } from 'features/networkAi/selectors'
import {
  fetchOrgAdminsThunk,
  inviteOrgAdminsThunk,
} from 'features/networkAi/slice'
import { OrgAdminInvite } from 'features/networkAi/types'

export function InviteAdminToSite(organizationId: string, siteId: string) {
  const dispatch = useDispatch()
  const { email, firstName, lastName } = useAppSelector(currentUserSelector)
  const orgAdmins = useAppSelector(orgAdminsFetchDataSelector.data)
  const isAdminsLoading = useAppSelector(orgAdminsFetchDataSelector.isFetching)
  const [inviteSent, setInviteSent] = useState(false)

  useEffect(() => {
    dispatch(fetchOrgAdminsThunk(organizationId))
  }, [dispatch, organizationId])

  useEffect(() => {
    const userInvite: OrgAdminInvite = {
      email: email,
      first_name: firstName,
      last_name: lastName,
      hours: 24,
      privileges: [
        {
          scope: 'org',
          org_id: organizationId,
          role: 'write',
        },
      ],
    }
    const sendInvite = async () => {
      await dispatch(inviteOrgAdminsThunk(organizationId, userInvite))
    }

    if (
      orgAdmins !== null &&
      email !== undefined &&
      !isAdminsLoading &&
      !inviteSent
    ) {
      let matchedEmailAdmin = orgAdmins.find((o) => o.email === email)

      if (matchedEmailAdmin === undefined) {
        //Can't find email at all
        sendInvite()
        setInviteSent(true)
      } else {
        /*
                let isMatchedSiteAdmin = false
                matchedEmailAdmin.privileges.forEach(function (value) {
                    if (value.site_id===siteId){
                        isMatchedSiteAdmin = true
                    }
                })
                if (!isMatchedSiteAdmin){ //Can't find this site
                    console.log('Sending Invite for Site')
                    sendInvite()
                    setInviteSent(true)
                } else {
                    setInviteSent(true)
                }
                */
        setInviteSent(true)
      }
    }
  }, [
    dispatch,
    orgAdmins,
    inviteSent,
    firstName,
    lastName,
    email,
    isAdminsLoading,
    organizationId,
    siteId,
  ])

  return 'organizationId'
}
